import Blockly from "blockly";
import helpers from "blocks/helpers";

Blockly.Blocks.TurnClockwise = {
  message0: `turn right by %1 degrees`,
  args0: [
    {
      type: "input_value",
      name: "degrees",
      check: "Number",
    },
  ],
  previousStatement: "Statement",
  nextStatement: "Statement",
};

Blockly.Blocks.TurnClockwise.init = function () {
  this.jsonInit(Blockly.Blocks.TurnClockwise);
};

Blockly.JavaScript.TurnClockwise = function (block) {
  const degrees = helpers.codeForArg("degrees", block);

  if (typeof degrees === "undefined") {
    return "";
  } else {
    return `visualisation.turnClockwise(${degrees});`;
  }
};
